import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Motion";
import PageHeader from "../components/layout/PageHeader";
import { api } from "../lib/api";
import SEO from "../components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        route="blog"
        fallbackTitle="Blog | Shaan Curry House"
        fallbackDescription="Recipes, catering advice and stories from Ottawa's favourite Indian kitchen."
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Blog", url: "/blog" },
        ]}
      />
      <PageHeader
        eyebrow="The Journal"
        title="Stories & Spice"
        subtitle="Recipes, catering tips and tales from Ottawa's favourite Indian kitchen."
      />

      {/* LISTING */}
      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28">
        {loading ? (
          <p className="text-neutral-400 text-lg">Loading stories…</p>
        ) : (
          <StaggerGroup className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p) => (
              <StaggerItem key={p.slug}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                  className="group block bg-[#141414] rounded-2xl overflow-hidden border border-white/10 hover:border-[#ffd100]/50 transition-colors h-full">
                  <div className="relative h-52 overflow-hidden">
                    <img src={p.image} alt={p.title} loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <span className="absolute top-4 left-4 bg-[#ffd100] text-[#0a0a0a] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">{p.category}</span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-neutral-500 text-sm mb-3">
                      <Clock size={15} /> {p.read_time}
                    </div>
                    <h2 className="font-display text-xl md:text-2xl font-medium text-white leading-snug group-hover:text-[#ffd100] transition-colors">{p.title}</h2>
                    <p className="text-neutral-400 text-base mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-[#ffd100] font-medium group-hover:gap-3 transition-all">
                      Read more <ArrowRight size={18} />
                    </span>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </StaggerGroup>
        )}
      </section>
    </div>
  );
}
